// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"93779583","105":"4a5507a9","221":"e0fdd3cc","239":"78f517e9","264":"d3f687da","453":"576e89bd","455":"2c26f999","548":"f8a36e9c","977":"430162d1"}[chunkId] + ".chunk.js";
};